import object from 'helpers/object'


export const initialState = {
  categories: [],
  times: [],
  tariffs: [],
  isFetching: true,
}


export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setTimes = (state, payload) => (
  object.setIn(state, [ 'times' ], payload)
)

export const setTariffs = (state, payload) => (
  object.setIn(state, [ 'tariffs' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
